import { render, staticRenderFns } from "./AllGFContributions.vue?vue&type=template&id=df53a34c&scoped=true"
import script from "./AllGFContributions.vue?vue&type=script&lang=js"
export * from "./AllGFContributions.vue?vue&type=script&lang=js"
import style0 from "./AllGFContributions.vue?vue&type=style&index=0&id=df53a34c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "df53a34c",
  null
  
)

export default component.exports